export default "/images/zoom.png?516bb2832c3f2af472a338e5833350d5";